import { useContext, useState } from "react";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../store/ui-context";

export const useAPISaveDeviceToken = (props) => {
  const { onConfirm } = props;

  const uiContext = useContext(UiContext);
  const { requestPost, loading } = useAPIRequest();

  const saveData = async (bodyData) => {

    return requestPost({
      fullUrl: `/api/masterdata/devicetoken/save-fcm-token`,
      body: bodyData,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        onConfirm(_data);
      },
    });
  };

  return {
    loading,
    saveData,
  };
};
